<template>
  <section class="interesting constructor_section">
    <div class="section-header">
      {{ data.title }}
    </div>

    <div
      ref="card"
      class="product-content"
      :class="isBanner ? 'product-content--banner' : ''"
    >
      <a
        v-if="data.banner.to"
        :href="data.banner.to"
        target="_blank"
        @click="
          sendEvents(data.banner);
          $emit('promo-banner-click');
        "
      >
        <img
          v-if="data.banner.image"
          :src="data.banner.image"
          alt="banner"
          class="product-banner"
        />
      </a>
      <img
        v-else-if="data.banner.image"
        :src="data.banner.image"
        alt="banner"
        class="product-banner"
      />
      <div class="slider-wrap">
        <ui-multiple-swiper :white_buttons="true" class="slider">
          <ui-multiple-swiper-slide
            v-for="(item, index) in data.items"
            :key="`${item.id}_${index}`"
            class="link-wrap"
          >
            <sticker-marker
              v-if="item.discount && item.discount.percent"
              type="percent"
              :show-graduation="true"
              class="percent"
              :text="item.discount.percent"
            />
            <cpc-link
              class="item"
              :offer="item"
              :position="index + 1"
              :to="item.click_url"
              :data-slot="index + 1"
              :data-url="objToBase64({ url: item.view_url })"
              :data-offer_id="item.id"
              @send-analytics="(value) => $emit('sendAnalytics', value)"
            >
              <div class="text">
                <div class="img__wrap">
                  <div class="img__container">
                    <responsive-image
                      :src="item.image"
                      :alt="item.name"
                      :lazy="true"
                      draggable="false"
                      class="img"
                      :mobile-sizes="{ width: 120, height: 120 }"
                      :desktop-sizes="{ width: 224, height: 224 }"
                    />
                  </div>
                </div>
                <div class="name">{{ item.name }}</div>
                <div class="currency-wrap">
                  <currency :value="item.price" class="price" />
                  <currency
                    v-if="item.discount && item.discount.price_before"
                    :value="item.discount.price_before"
                    class="old-price"
                  />
                </div>
              </div>
              <div class="store">
                <span v-if="item.cpo">Купить</span>
                <div v-else class="to-shop">
                  <span class="to-shop-text">
                    {{ (item.shop_info && item.shop_info.name) || 'В магазин' }}
                  </span>
                  <img
                    class="icon-arrow l-icon-arrow"
                    src="~/assets/images/arrow-left-b.svg"
                    alt=""
                  />
                </div>
              </div>
              <p
                class="advertising-marker advertising-marker-none l-mtop l-a_left"
              >
                {{ `Реклама, ${advertising(item)}` }}
              </p>
            </cpc-link>
          </ui-multiple-swiper-slide>
        </ui-multiple-swiper>
      </div>
    </div>

    <a
      :href="data.links.to"
      target="_blank"
      class="link"
      @click="sendEvents(data.links)"
    >
      <span class="text">Смотреть все</span>
      <span class="slider_triangle__wrapper">
        <span class="slider_triangle slider_triangle--right">
          <span
            class="slider_triangle__elem"
            :style="{ backgroundColor: '#363EF8' }"
          />
        </span>
      </span>
    </a>
  </section>
</template>

<script lang="ts" src="./customTs.ts"></script>
<style lang="scss" src="./custom.scss" scoped></style>
